import { render, staticRenderFns } from "./IconCard.vue?vue&type=template&id=3b4f7c0c&scoped=true"
import script from "./IconCard.vue?vue&type=script&lang=js"
export * from "./IconCard.vue?vue&type=script&lang=js"
import style0 from "./IconCard.vue?vue&type=style&index=0&id=3b4f7c0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4f7c0c",
  null
  
)

export default component.exports